import axios from './myAxios'
import { stringify } from 'qs'


//name of resource, parameters object, cache: false, or number in seconds of maximum age, rawResponse returns raw response
export const getResource = (name, params={}, cache=false, rawResponse=false) =>{
    let queryObj = {resource: name, ...params}
    // let ignoreCache = !cache
    let maxAge
    if (typeof cache == "number"){
        maxAge = cache
    }else{
        maxAge=0
    }
	
    return new Promise((resolve, reject) => {
        axios.get('',
            {
                params: {
                    params:
                    {
                        resources:
                            [
                                queryObj
                            ]
                    }
                },
                ttl: maxAge //set caching time
            }
        ).then(response => {
			
            if(rawResponse){
				
                return resolve(response)
            }
            if (response.data && name in response.data) {
				//console.log(response.data[name]);
                return resolve(response.data[name])
            } 
			if (name == "window_products" && response.data && "products" in response.data) {
				
				return resolve(response.data["products"])
			}
            if (response.data && response.data.message && response.data.message.text) {
				
                return reject(response.data.message.text)
            }
			
            return reject(response.data)
        }).catch(err => {
            reject(err)
        })
    })
}

export const postForm = (name, form_values = {}, rawResponse=false) => {
    var data_obj = {
        form: name,
        form_values: form_values
    }

    // this is funky because of https://github.com/axios/axios#using-applicationx-www-form-urlencoded-format
    var data = {
        "params": JSON.stringify(data_obj)
    }

    return new Promise((resolve, reject) => {
        axios.post('/', stringify(data), {ttl:0})
        .then(response => {
            if (rawResponse){
                return resolve(response)
            }
            if (response.data && response.data[name]) {
                resolve(response.data[name])
            } else {
                console.log("error with post request")
                reject(response)
            }
        }).catch(reject)
    }) 
}